<template>
  <VueEasyLightbox
    class="vel-modal-custom"
    :visible="innerIndex != null ? true : false"
    :imgs="images"
    :index="innerIndex"
    :scrollDisabled="false"
    :moveDisabled="true"
    :loop="images > 1 ? true : false"
    @hide="innerIndex = null"
  >
    <template v-slot:toolbar><div></div></template>
  </VueEasyLightbox>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'
export default {
  components: {
    VueEasyLightbox,
  },
  computed: {
    innerIndex:{
        get() {
          return this.index;
        },
        set(value) {
          this.$emit('reset',value);
        }
    }
  },
  props:  {
    index : {
      default : null
    },
    images : {
      type : Array,
      default : () => []
    },
  }
};
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.vel-modal-custom {
  background: rgba(0,0,0,.85) !important;
}
</style>
